module.exports = __webpack_public_path__ + "static/media/Start game.1196be61.png";